import React, { useEffect, useState, useRef } from 'react';
import { fetcher } from '../../../../../helpers/fetcher';
import { configApiLinks } from '../../../../../configApiLinks';

export const useReceiptList = (inFrId = 0) => {
  const [modalShow, setModalShow] = useState(false);
  const [checkDataHistory, setCheckDataHistory] = useState({});
  const [showLoader, setShowLoader] = useState(true);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [searchText, setSearchText] = useState('');
  const [frId, setFrId] = useState(inFrId);

  useEffect(() => {
    if (modalShow === true) {
      setFrId(inFrId);
      fetcher(configApiLinks.getChecksHistory, 'POST', {
        date: Date.parse(startDate),
        dateEnd: Date.parse(endDate),
        fiscalRegistrarId: inFrId
      }).then((data) => {
        setCheckDataHistory(data);
        setShowLoader(false);
      });
    }
  }, [modalShow]);

  // useEffect(() => {
  //   frIdRef.current = frId;
  //   triggerSearchByDate(startDate, endDate);
  // }, [frId]);

  const triggerSearch = (event, pFrId) => {
    if (frId !== pFrId) {
      setFrId(pFrId);
    }
    const searchText = event.target.value;
    setSearchText(searchText);
    setShowLoader(true);
    fetcher(configApiLinks.getChecksHistory, 'POST', {
      date: Date.parse(startDate),
      dateEnd: Date.parse(endDate),
      sphrase: searchText,
      fiscalRegistrarId: frId
    }).then((data) => {
      setShowLoader(false);
      setCheckDataHistory(data);
    });
  };

  const triggerSearchByDate = (inDate, inDateEnd, pFrId) => {
    if (frId !== pFrId) {
      setFrId(pFrId);
    }
    if (startDate !== inDateEnd) {
      setStartDate(inDate);
    }
    if (endDate !== inDateEnd) {
      setEndDate(inDateEnd);
    }
    setShowLoader(true);
    fetcher(configApiLinks.getChecksHistory, 'POST', {
      date: Date.parse(inDate),
      dateEnd: Date.parse(inDateEnd),
      sphrase: searchText==='' ? undefined : searchText,
      fiscalRegistrarId: pFrId
    }).then((data) => {
      setShowLoader(false);
      setCheckDataHistory(data);
    });
  };

  // here we put
  const delay = (callback, ms) => {
    let timer = 0;
    // return function because keyup require function
    return function () {
      let context = this;
      let args = arguments;
      // if we put something again clear timer (do not wait for result function below) amd start timer again
      clearTimeout(timer);
      timer = setTimeout(function () {
        // runs function on key up ajax send format url etc...
        callback.apply(context, args);
      }, ms);
    };
  };
  return {
    delay,
    triggerSearchByDate,
    triggerSearch,
    modalShow,
    checkDataHistory,
    showLoader,
    searchText,
    startDate,
    endDate,
    setModalShow,
    frId,
    setFrId
  };
};
